'use strict';

if (!Array.of) {
  require('./array-of');
}



//////////////////
// WEBPACK FOOTER
// ./~/array.of/detect.js
// module id = 4
// module chunks = 0